module.exports = __webpack_public_path__ + "static/media/mp-logo.9d578be1.png";